<template lang="html">
 <div>
    <!-- <FullCalendar
      defaultView="dayGridMonth"
      :plugins="calendarPlugins"
      :weekends="false"
      googleCalendarApiKey="AIzaSyBXJuvD8iYPY7Obq7o9dI999Q-ZdUAg-n8",
      :events="{googleCalendarId: '413001240274-n1t140gg3htus5ue417hobtap657ffiv.apps.googleusercontent.com'}"
      
      /> -->
      <!-- <md-layout>
        <md-layout md-flex="50" style="margin-bottom: 10px">
          <md-input-container style="margin:auto; width:100%" >
            <label>Buscar</label>
            <md-input v-model="calendarId"></md-input>
          </md-input-container>
        </md-layout>
        <md-layout md-flex="10" style="margin-bottom: 10px">
          <md-button class="md-accent" @click.native="showCalendar">consultar </md-button>
        </md-layout>
      </md-layout>
      <div id='calendar'></div>
   
  </div> -->
  <!-- <iframe width="980" height="600" src="https://mars.nasa.gov/layout/embed/send-your-name/mars2020/certificate/?cn=614658592941" frameborder="0"></iframe> -->

  <!-- <div>
    <md-layout>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
    ></div>
    </md-layout> -->
  </div>
</template>

<script type="text/javascript">
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timelinePlugin from '@fullcalendar/timeline'
import listPlugin from '@fullcalendar/list'
import timegridPlugin from '@fullcalendar/timegrid'
import { Calendar } from '@fullcalendar/core';
import googleCalendarPlugin from '@fullcalendar/google-calendar';
import VueGallery from 'vue-gallery';

export default {
  name: 'Pedidos',
  data() {
    return {
      calendarPlugins: [ dayGridPlugin, googleCalendarPlugin, listPlugin, timegridPlugin ],
      calendarId: 'diegochilomer@gmail.com',
      calendar: null,
      images: [
          'https://dummyimage.com/800/ffffff/000000',
          'https://dummyimage.com/1600/ffffff/000000',
          'https://dummyimage.com/1280/000000/ffffff',
          'https://dummyimage.com/400/000000/ffffff',
        ],
        index: null,
    };
  },
  computed: {
  },
  components: {
    FullCalendar,
    'gallery': VueGallery
  },
  methods: {
   showCalendar(){
    if(this.calendar)
      this.calendar.destroy();
    const calendarEl = document.getElementById('calendar');
    this.calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, googleCalendarPlugin, listPlugin, timegridPlugin ],
      defaultView: 'dayGridMonth',
      views: {
        dayGrid: {
          // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
        },
        timeGrid: {
          // options apply to timeGridWeek and timeGridDay views
        },
        week: {
          // options apply to dayGridWeek and timeGridWeek views
        },
        day: {
          // options apply to dayGridDay and timeGridDay views
        }
      },
      googleCalendarApiKey: 'AIzaSyBXJuvD8iYPY7Obq7o9dI999Q-ZdUAg-n8',
      events: {
        googleCalendarId: 'Representaciones.ccij1@gmail.com'
      }
    });
    this.calendar.render();
   },
  },
  mounted() {
    this.showCalendar();
  },
};
</script>

<style lang="scss">
@import '../../../node_modules/@fullcalendar/core/main.css';
@import '../../../node_modules/@fullcalendar/daygrid/main.css';
@import '../../../node_modules/@fullcalendar/list/main.css';
@import '../../../node_modules/@fullcalendar/timegrid/main.css';
.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
    width:100px;
  }

</style>



// WEBPACK FOOTER //
// src/spa/calendar/Calendar.vue